module.exports = __webpack_public_path__ + "img/dubai-hotel.53163f59.jpg";